module.exports = __webpack_public_path__ + "img/counter_handycap.e6b52622.svg";